import { useCallback, useEffect } from 'react';
import { useEyeconxStore } from '../../store/eyeconxStore';
import clinicFeaturesService from './clinicFeatures.service';

function ClinicFeaturesLoader() {
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);
    const setClinicFeatures = useEyeconxStore((state) => state.setClinicFeatures);
    const setClinicFeaturesLoading = useEyeconxStore((state) => state.setClinicFeaturesLoading);
    const clearClinicFeatures = useEyeconxStore((state) => state.clearClinicFeatures);

    const fetchClinicFeatures = useCallback(async () => {
        if (!clinicId) {
            return;
        }

        setClinicFeaturesLoading(true);

        try {
            const res = await clinicFeaturesService.getClinicFeatures(clinicId);
            setClinicFeatures(res.data || {});
        } catch (error) {
            console.error('Failed to fetch clinic features:', error);
            clearClinicFeatures();
        }
    }, [clinicId, clearClinicFeatures, setClinicFeatures, setClinicFeaturesLoading]);

    useEffect(() => {
        if (!clinicId) {
            clearClinicFeatures();
            return;
        }

        fetchClinicFeatures();
    }, [clinicId, clearClinicFeatures, fetchClinicFeatures]);

    return null;
}

export default ClinicFeaturesLoader;
